interface DayTotal {
  date: string
  [key: string]: number | string
}

export function createBarChartSeries(
  specificDateTotals: DayTotal[] | undefined,
  type: keyof DayTotal
): { name: string; data: { x: string; y: number }[] }[] {
  const today = new Date()

  const totalsByDay =
    specificDateTotals?.reduce<Record<string, DayTotal>>((acc, cur) => {
      acc[new Date(cur.date).toISOString().split('T')[0]] = cur
      return acc
    }, {}) || {}

  const data = Array.from({ length: 30 }, (_, i) => {
    const date = new Date(today)
    date.setDate(today.getDate() - (29 - i)) // oldest-to-newest
    const key = date.toISOString().split('T')[0]
    const y = Number(totalsByDay[key]?.[type] ?? 0)
    return { x: key, y }
  })

  return [
    {
      name: 'Chart Series',
      data,
    },
  ]
}
